import { magnetar } from '@/magnetarSetup.js';

export const usersModule = magnetar.collection('users');

export const subscribeToUser = async userId => {
  const userModule = usersModule.doc(userId);
  await userModule.fetch();
  userModule.stream();
  return;
};